export async function getCountryCode(lat, lng) {
  const apiKey = "2e0965b348cc43a4a7e65274c95a38ae";
  const url = `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&key=${apiKey}`;

  try {
    const res = await fetch(url);
    const json = await res.json();
    return json?.results?.[0]?.components?.country_code?.toUpperCase() || null;
  } catch (err) {
    console.warn("Geocoding error:", err);
    return null;
  }
}

export async function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => reject(error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  });
}
